import { IconType } from '@/components/icon/helpers';
import { ClassifierCreateOption } from '@/lib/models/classifier';

export type RegexPatternTemplate = {
  id: string;
  icon: IconType;
  title: string;
  summary: string;
  description: string;
  regexPattern: string;
  sampleTestText: string;
};

export const REGEX_PATTERN_TEMPLATES: RegexPatternTemplate[] = [
  {
    id: 'ticket-id',
    icon: 'regex',
    title: 'Ticket ID',
    summary: 'Ticket IDs like ABC-1234',
    description:
      'Matches issue tracker ticket IDs with a project key and four digits, in any letter case. This matches ABC-1234, abc-1234 and Abc-1234, but not ABC-wxyz. Each letter is written as a bracketed pair so it matches either case — replace them with your own project key, for example [Xx][Yy][Zz] for XYZ, and change the digit count to match your tracker.',
    regexPattern: String.raw`[Aa][Bb][Cc]-\d{4}`,
    sampleTestText:
      'Please prioritize ABC-1234 this sprint. Also abc-5678 and Abc-9012 match. ABC-wxyz should not match. Related: ABC-0001.',
  },
  {
    id: 'git-commit-sha',
    icon: 'regex',
    title: 'Git commit SHA',
    summary: 'Short or full lowercase hex hashes',
    description:
      'Matches Git-style commit hashes in agent or developer conversations. Uses a bounded hex run so match preview stays safe; use {40} only if you require full-length SHAs.',
    regexPattern: String.raw`\b[a-f0-9]{7,40}\b`,
    sampleTestText:
      'Merged fix a3f9c2e to main. Deploy 1a2b3c4d5e6f7890abcdef0123456789abcdef01 when ready. Not a sha: xyz.',
  },
];

export const getRegexPatternTemplateById = (templateId: string): RegexPatternTemplate | undefined =>
  REGEX_PATTERN_TEMPLATES.find((template) => template.id === templateId);

export const CLASSIFIER_OPTIONS: {
  type: ClassifierCreateOption;
  icon: IconType;
  title: string;
  description: string;
}[] = [
  {
    type: 'intent' as ClassifierCreateOption,
    icon: 'tips-and-updates',
    title: 'Custom Intent',
    description:
      'Understand meaning, not just keywords. Use vector-powered semantic matching to classify user prompts by intent topic.',
  },
  {
    type: 'regex' as ClassifierCreateOption,
    icon: 'regex',
    title: 'Custom Entity',
    description:
      'Match precise patterns in text. Use regex to detect specific formats, identifiers, or structured data.',
  },
];
